import { MATERIAL_HUB_FAVORITES_KEY } from '@/pages/ipe/workbench/constants/materialHubConfig';
import { userLocal } from '@/utils/ipeUserLocalState';

export function pickFavoriteSnapshot(item) {
  if (!item?.id) return null;
  return {
    id: String(item.id),
    title: item.title || '',
    url: item.url || '',
    premium: !!item.premium,
    sourceType: item.sourceType || item.source || '',
    category: item.category || '',
    fissionBatchId: item.fissionBatchId || '',
  };
}

export function loadMaterialHubFavorites() {
  try {
    const parsed = userLocal.getJson(MATERIAL_HUB_FAVORITES_KEY, []);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map((entry) => {
        if (typeof entry === 'string') return { id: entry };
        if (entry && entry.id) return { ...entry, id: String(entry.id) };
        return null;
      })
      .filter(Boolean);
  } catch {
    return [];
  }
}

export function saveMaterialHubFavorites(favorites) {
  try {
    userLocal.setJson(MATERIAL_HUB_FAVORITES_KEY, favorites);
  } catch {
    /* ignore */
  }
}

export function clearMaterialHubFavoritesForLogout() {
  userLocal.dropLegacyKeys(MATERIAL_HUB_FAVORITES_KEY);
}

export function mergeFavoriteSnapshots(favorites, items) {
  if (!items?.length || !favorites?.length) return favorites;
  let changed = false;
  const next = favorites.map((fav) => {
    const hit = items.find((item) => String(item.id) === String(fav.id));
    if (!hit) return fav;
    const snapshot = pickFavoriteSnapshot(hit);
    const merged = { ...fav, ...snapshot };
    if (JSON.stringify(merged) !== JSON.stringify(fav)) changed = true;
    return merged;
  });
  return changed ? next : favorites;
}
